export default "/images/d8699e4c7322d77a1c53e58a0cdf8e14.png";